import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './ArrowButton.scss';

const propTypes = {
  size: PropTypes.string,
  padLeft: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};
const defaultProps = {
  size: '20px',
  padLeft: '',
  className: '',
};

const arrow = require('./assets/left-arrow.png');

const ArrowButton = ({
  size, className, onClick, padLeft,
}) => {
  const arrowButtonClasses = classNames({
    'arrow-button': true,
    [`${className}`]: true,
  });
  return (
    <button onClick={onClick} type="button" style={{ width: size, left: `${padLeft}px` }} className={arrowButtonClasses}>
      <img src={arrow} alt="left arrow" />
    </button>
  );
};

ArrowButton.propTypes = propTypes;
ArrowButton.defaultProps = defaultProps;
export default ArrowButton;



// WEBPACK FOOTER //
// ./src/components/_atomic/ArrowButton/ArrowButton.js